import React, { useState } from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@mui/material';

const SelectionDraftActions = ({
    itemLabel,
    additions,
    removals,
    isSaving,
    saveError,
    onDiscard,
    onSubmit,
}) => {
    const [reviewOpen, setReviewOpen] = useState(false);
    const hasChanges = additions.length > 0 || removals.length > 0;

    const handleSubmit = async () => {
        const saved = await onSubmit();
        if (saved) {
            setReviewOpen(false);
        }
    };

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 2,
                    flexWrap: 'wrap',
                    pt: 2,
                }}
            >
                <Box>
                    <Typography variant="body2" color={saveError ? 'error' : 'text.secondary'}>
                        {saveError || (hasChanges
                            ? `${additions.length} to share, ${removals.length} to remove.`
                            : 'No pending changes.')}
                    </Typography>
                    {hasChanges && (
                        <Typography variant="caption" color="text.secondary">
                            Your changes are saved only after submission.
                        </Typography>
                    )}
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button onClick={onDiscard} disabled={!hasChanges || isSaving}>
                        Discard
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => setReviewOpen(true)}
                        disabled={!hasChanges || isSaving}
                    >
                        Review Changes
                    </Button>
                </Box>
            </Box>

            <Dialog open={reviewOpen} onClose={() => !isSaving && setReviewOpen(false)} fullWidth maxWidth="xs">
                <DialogTitle>Review {itemLabel} changes</DialogTitle>
                <DialogContent>
                    <Typography variant="body2">
                        Share: {additions.length}
                    </Typography>
                    <Typography variant="body2">
                        Remove: {removals.length}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                        This sends one batch per required operation. The final selection is committed after both requests succeed.
                    </Typography>
                    {saveError && (
                        <Typography variant="body2" color="error" sx={{ mt: 2 }}>
                            {saveError}
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setReviewOpen(false)} disabled={isSaving}>
                        Back
                    </Button>
                    <Button variant="contained" onClick={handleSubmit} disabled={isSaving}>
                        {isSaving ? 'Saving...' : 'Submit Changes'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default SelectionDraftActions;
